import useResize from "components/Hooks/useResize";
import { stringMinify } from "utils/StringUtils";
import dynamic from "next/dynamic";
import { DeviceEnum } from "models/enums";
import { gaevent } from "components/GAEvent/gaevent";

const HtmlComponent = dynamic(() => import("components/Html/Html"));

const ButtonLink = ({ item, index }: { item: any; index: number }) => {
    const { whichDevice } = useResize();
    const isMobileDevice = whichDevice === DeviceEnum.MOBILE;

    const showButton = item.showButton;
    const showButtonMobile = item.showButtonMobile;

    if (
        (!showButton && !isMobileDevice) ||
    (!showButtonMobile && isMobileDevice)
    ) {
        return <></>;
    }

    const buttonText = item.buttonText;
    const linkButton =
    item.customLink && item.customLink !== ""
        ? item.customLink
        : item.buttonLink;
    const textColor = item.textColor;
    const backgroundColor = item.backgroundColor;
    const textHoverColor = item.textHoverColor;
    const backgroundHoverColor = item.backgroundHoverColor;
    const customClass = item.customClass;
    const customId = item.customId;
    let cssButtonClass = item.cssButtonClass;
    const useSkinColor = item.useSkinColor;
    const openInNewPage = item.openInNewPage;

    let cssButtonStyle = null;
    if (!useSkinColor) {
        cssButtonClass = `vdp-action-button-${index}`;
        cssButtonStyle = `
    .${cssButtonClass} {
        background: ${backgroundColor} !important;
        background-color: ${backgroundColor} !important;
        color: ${textColor} !important;
    }
    .${cssButtonClass}:hover {
        background: ${backgroundHoverColor}  !important;
        background-color: ${backgroundHoverColor} !important;
        color: ${textHoverColor} !important;
    }`;
    }

    return (
        <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-12 col-sm-12 text-center">
                {cssButtonStyle && (
                    <style jsx>{`
                ${stringMinify(cssButtonStyle)}
              `}</style>
                )}
                {linkButton && (
                    <a
                        id={customId}
                        href={linkButton}
                        className={`button col-xs-12 ${cssButtonClass} ${
                            useSkinColor ? "red" : ""
                        } ${customClass}`}
                        target={openInNewPage ? "_blank" : "_self"}
                        rel="noreferrer"
                        onClick={()=> (item.gaCustomAction && item.gaCustomCategory) ? gaevent({action: item.gaCustomAction, category: item.gaCustomCategory, label: item.gaCustomLabel, value: item.gaValue}) : null}
                    >
                        {buttonText && <HtmlComponent key={index} htmlValue={buttonText} />}
                    </a>
                )}
                {(!linkButton || linkButton === 'javascript:void(0)' || linkButton === '#' || linkButton === '') && (
                    <button
                        id={customId}
                        className={`button col-xs-12 ${cssButtonClass} ${
                            useSkinColor ? "red" : ""
                        } ${customClass}`}
                    >
                        {buttonText && <HtmlComponent key={index} htmlValue={buttonText} />}
                        {cssButtonStyle && (
                            <style jsx>{`
                ${stringMinify(cssButtonStyle)}
              `}</style>
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default ButtonLink;
